module.exports = "https://deal-img.imgix.net/consumer/modern/diamond.cf5f8746.png";